import React, { useSyncExternalStore } from "react";
import { getConsent, subscribeConsent, type Consent } from "@/lib/analytics/consent";
import { isConfigPresent } from "@/lib/analytics/posthog";
import { CustomerChatWidget } from "@/components/customer-chat/CustomerChatWidget";
import { VapiButton } from "@/components/vapi/VapiButton";
import { FloatingWhatsAppButton } from "@/components/FloatingWhatsAppButton";
import { cn } from "@/lib/utils";

/**
 * A wrapper for floating controls (WhatsApp, Chat, and Voice) that adjusts
 * their position when the ConsentBanner is visible to prevent overlap.
 * 
 * The group is positioned on the right side.
 * Order: WhatsApp (Top) -> Chat -> Voice (Bottom)
 */
export function FloatingAiControls() {
  const consent = useSyncExternalStore(
    subscribeConsent,
    getConsent,
    () => "unset" as Consent,
  );
  
  const showBanner = isConfigPresent() && consent === "unset";

  // Position is fixed relative to bottom.
  // Default (no banner): sits at bottom-0, effectively using the padding inside components.
  // With banner: Lifted by 200px to clear the consent banner.
  const bottomValue = showBanner ? "200px" : "0px";

  return (
    <div 
      className={cn(
        "fixed right-0 z-[70] flex flex-col items-end transition-all duration-300 pointer-events-none gap-4 pb-6 sm:pb-8"
      )}
      style={{ bottom: bottomValue }}
    >
      <div className="pointer-events-auto">
        <FloatingWhatsAppButton />
      </div>
      <div className="pointer-events-auto">
        <CustomerChatWidget />
      </div>
      <div className="pointer-events-auto">
        <VapiButton />
      </div>
    </div>
  );
}
